// View routing resolved through the core LanguageRegistry instead of a hardcoded
// markdown-extension check. A file's supported editor views come from its resolved
// language, so a built-in language plugin can add or remove views by registering or
// disposing in the registry. `supportsRichViews` is the drop-in for the old
// `isMarkdownFile` view gate (markdown is the only language carrying `wysiwyg`).

import { languageRegistry, type ViewCapability } from '@slate/core';

/** The editor views a file supports, resolved through the language registry. */
export function viewCapabilitiesFor(fileName: string): readonly ViewCapability[] {
  return languageRegistry.resolveForFile(fileName).views;
}

/** True when a file gets the rich (WYSIWYG + rendered) experience, i.e. all three
 *  views. Drop-in replacement for the old isMarkdownFile view-routing gate. */
export function supportsRichViews(fileName: string): boolean {
  return viewCapabilitiesFor(fileName).includes('wysiwyg');
}
